//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[[0,"AdjustedOrigin",0,0],[0,"Height",0,0],[0,"Length",0,0],[0,"NumberLines",0,0],[0,"Origin",0,0],[0,"Type",0,0]],[[[],"Dispose",{},0,0],[["numberLinesText"],"GetText",{R_:{text:""}},0,0],[[],"GetDistanceToTop",{R_:{distanceToTop:''}},0,0],[["nth"],"GetIntegerizedLength",{R_:{integerizedLength:''}},1,0],[[],"GetAngle",{R_:{angle:''}},0,0]],[]];
SPLM.Annotations.TextComponent = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TextComponent";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.TextComponent.TextType = Object.freeze({
    "Text" : "Text", "DualDimension" : "DualDimension", "Tolerance" : "Tolerance", "DualTolerance" : "DualTolerance", "DiameterRadius" : "DiameterRadius", "AppendedAbove" : "AppendedAbove", "AppendedBelow" : "AppendedBelow", "AppendedBefore" : "AppendedBefore", "AppendedAfter" : "AppendedAfter", "ChamferBefore" : "ChamferBefore", "ChamferAfter" : "ChamferAfter", "ChamferSize" : "ChamferSize", "ChamferXSymbol" : "ChamferXSymbol", "ChamferAngle" : "ChamferAngle"});

export default SPLM;